export const timetableCCChoreography = [
  // Row 1 8-9ish
  {
    Saturday: {
      Class: 'Acro Intermediates (Yr 4+)',
      Time: '8.30 - 9.15am'
    }
  },
  // Row 2 9-10ish
  {
    Tuesday: {
      Class: 'Lil Groovers',
      Time: '9.30 - 10.15am'
    },
    Wednesday: {
      Class: 'Lil Groovers',
      Time: '9.30 - 10.15am'
    },
    Thursday: {
      Class: 'Lil Groovers',
      Time: '9.30 - 10.15am'
    },
    Friday: {
      Class: 'Lil Groovers',
      Time: '9.30 - 10.15am'
    },
    Saturday: {
      Class: 'Acro Juniors (K - Yr3)',
      Time: '9.15 - 10am'
    }
  },
  // Row 3 10-11ish
  {
    Saturday: {
      Class: [
        { class: 'Lil Acro (2 - 5 yrs)', time: '10 - 10.30am' },
        { class: 'Lil Ballet (2 - 5 yrs)', time: '10.30 - 11am' }
      ],
      Time: ''
    }
  },
  // Row 4 3.15 - 3.45ish
  {
    Tuesday: {
      Class: 'Private (Eliza)',
      Time: '3.15 - 3.45pm'
    },
    Friday: {
      Class: 'Private Lessons',
      Time: 'From 3.30pm'
    }
  },
  // Row 5 3:45-4:30ish
  {
    Monday: {
      Class: 'Ballet 2 (Yr 4 - Yr 6)',
      Time: '3.45 - 4.30pm'
    },
    Tuesday: {
      Class: '12&U Troupe',
      Time: '3.45 - 4.45pm'
    },
    Wednesday: {
      Class: 'Yr 1/2 Jazz',
      Time: '3.45 - 4.30pm'
    },
    Thursday: {
      Class: 'Private (Lydia)',
      Time: '3.30 - 4pm'
    },
  },
  // Row 6 4-5ish
  {
    Monday: {
      Class: 'Ballet 3 (Yr 7+)',
      Time: '4.30 - 5.15pm'
    },
    Tuesday: {
      Class: 'Technique',
      Time: '4.45 - 5.15pm'
    },
    Wednesday: {
      Class: 'Yr 1/2 Contemp.',
      Time: '4.30 - 5.15pm'
    },
    Thursday: {
      Class: '15&O Troupe',
      Time: '4 - 5pm'
    }
  },
  // Row 7 5:15--6ish
  {
    Monday: {
      Class: 'Private (Ava & Aria)',
      Time: '5.15 - 5.45pm'
    },
    Tuesday: {
      Class: 'Yr 8/9 Jazz',
      Time: '5.15 - 6pm'
    },
    Wednesday: {
      Class: 'Yr 5/6 Jazz',
      Time: '5.15 - 6pm'
    },
    Thursday: {
      Class: 'Technique',
      Time: '5 - 5.30pm'
    }
  },
  // Row 8 6-6:45ish
  {
    Monday: {
      Class: 'Private (Lydia)',
      Time: '5.45 - 6.15pm'
    },
    Tuesday: {
      Class: 'Yr 8/9 Contemp.',
      Time: '6 - 6.45pm'
    },
    Wednesday: {
      Class: 'Yr 5/6 Contemp.',
      Time: '6 - 6.45pm'
    },
    Thursday: {
      Class: 'Senior Jazz',
      Time: '5.30 - 6.30pm'
    }
  },
  // Row 9 6:45-7:45ish
  {
    Tuesday: {
      Class: 'Private (Evelyn & Isla)',
      Time: '6.45 - 7.15pm'
    },
    Wednesday: {
      Class: 'Private (Lexie)',
      Time: '6.45 - 7.15pm'
    },
    Thursday: {
      Class: 'Private (Addison)',
      Time: '6.30 - 7pm'
    }
  },
  // Row 10 7:15-8:15ish
  {
    Tuesday: {
      Class: 'Private (Evelyn)',
      Time: '7.15 - 7.45pm'
    }
  }
]

// Placeholder timetable for Tiny Tutus (Lambton) - will be updated with actual data
// Structure should match the timetable array above with days: Monday, Tuesday, Wednesday, Thursday, Friday, Saturday
// Each row should have: { Monday: { Class: '', Time: '' }, Tuesday: { Class: '', Time: '' }, ... }
export const timetableTinyTutus = [
  // Row 1 3:45-4:30ish
  {
    Monday: {
      Class: 'Kindy Ballet',
      Time: '4 - 4.30pm'
    },
    Tuesday: {
      Class: 'Boys Hip Hop (All Ages)',
      Time: '3.30 - 4.15pm'
    },
    Wednesday: {
      Class: 'Yr 3/4 Jazz',
      Time: '3.45 - 4.30pm'
    },
  },
  // Row 2 4.30-5.15ish
  {
    Monday: {
      Class: 'Kindy Jazz',
      Time: '4.30 - 5pm'
    },
    Tuesday: {
      Class: 'Junior Hip Hop Crew (K - Yr3)',
      Time: '4.15 - 5pm'
    },
    Wednesday: {
      Class: 'Yr 3/4 Contemp.',
      Time: '4.30 - 5.15pm'
    },
  },
  // Row 3 5 - 6ish
  {
    Monday: {
      Class: [
        { class: 'Ballet 1 (Yr 1 - Yr 3)', time: '5 - 5.30pm' },
        { class: 'Junior Jazz (Yr 1 - Yr 3)', time: '5.30 - 6pm' }
      ],
      Time: ''
    },
    Tuesday: {
      Class: 'Junior Musical Theatre (K - Yr3)',
      Time: '5 - 5.45pm'
    },
    Wednesday: {
      Class: 'Yr 7 Jazz',
      Time: '5.15 - 6pm'
    },
  },
  // Row 4 5 - 6ish
  {
    Monday: {
      Class: 'CC Cheerleaders',
      Time: '6 - 6.45pm'
    },
    Tuesday: {
      Class: 'Senior Musical Theatre (Yr 4+)',
      Time: '5.45 - 6.30pm'
    },
    Wednesday: {
      Class: 'Yr 7 Contemp.',
      Time: '6 - 6.45pm'
    },
  },
  // Row 4 6 - 6:45ish
  {
    Tuesday: {
      Class: 'Senior Hip Hop (Yr 4+)',
      Time: '6.30 - 7.15pm'
    },
  },
]